import { FormInstance } from "antd/es/form";
import { Guid } from "guid-typescript";
import _ from "lodash";
import React from "react";
import { IUserInfoDto } from "../../models/dto/user-info.dto";
import { IValidationData } from "../../models/dto/validation-data";
import { UserService } from "../../services/user-service";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface ISTDUsers_List_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface ISTDUsers_List_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GetUserWithGroupDetails: any[];
  GetUserWithGroupDetails_dummy: any[];
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  IfThenElse: boolean;
  IfThenElse_dummy: boolean;
  GetSTDUsersAll: any[];
  GetSTDUsersAll_dummy: any[];
  isComp91272Visible: "visible" | "hidden";
  isComp888154Visible: "visible" | "hidden";
  isComp8751Visible: "visible" | "hidden";
  isComp433981Visible: "visible" | "hidden";
  isComp352595Visible: "visible" | "hidden";
  isComp168464Visible: "visible" | "hidden";

  isMasterPageInitLoaded?: boolean;
  isMasterPageRecurringLoaded?: boolean;
  shouldTriggerPageInit?: boolean;
}

export class STDUsers_List_ScreenBase extends React.PureComponent<
  ISTDUsers_List_ScreenProps,
  any
> {
  stdusers_list_14084_value_kuikaTableRef: React.RefObject<any>;
  ml = [
    {
      Id: "25c1b361-4262-e567-aef0-4b8ceff8261c",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "ea2af393-7864-0865-c06a-2b07d10d3ec8",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [],
    },
    {
      Id: "102db64c-9ef9-4f10-b6f2-cd69565da1be",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 481477, PropertyName: "value", Value: "Kullanıcı Listesi" },
        { Id: 91272, PropertyName: "label", Value: "Kullanıcı Ekle" },
        { Id: 965147, PropertyName: "title", Value: "#" },
        { Id: 576436, PropertyName: "value", Value: "[datafield:numvalue]" },
        { Id: 468326, PropertyName: "title", Value: "İstasyon Adı" },
        { Id: 512997, PropertyName: "value", Value: "[datafield:fullname]" },
        { Id: 259949, PropertyName: "title", Value: "Email" },
        { Id: 34158, PropertyName: "value", Value: "[datafield:email]" },
        { Id: 680971, PropertyName: "title", Value: "Kullanıcı Grubu" },
        { Id: 538198, PropertyName: "value", Value: "[datafield:groupname]" },
        { Id: 684483, PropertyName: "title", Value: "Aktiflik" },
        { Id: 888154, PropertyName: "value", Value: "[datafield:status]" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  constructor(props) {
    super(props);
    this.stdusers_list_14084_value_kuikaTableRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GetUserWithGroupDetails: [],
      IfThenElse: false,
      GetSTDUsersAll: [],
      NAVIGATE: "",
      isComp91272Visible: "hidden",
      isComp888154Visible: "hidden",
      isComp8751Visible: "hidden",
      isComp433981Visible: "hidden",
      isComp352595Visible: "hidden",
      isComp168464Visible: "hidden",

      isMasterPageInitLoaded: false,
      isMasterPageRecurringLoaded: false,
      shouldTriggerPageInit: false,
    };

    this.CheckPageAuthorization(this.state);
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight(
        "stdusers_list",
        "layout2_screen"
      );
      return;
    }

    ReactSystemFunctions.validateToken();
    if (false) {
      await this.STDUsers_ListPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight(
      "stdusers_list",
      "layout2_screen"
    );

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  CheckPageAuthorization = async (state) => {
    KuikaAppManager.showSpinner(this);
    if (_.isEmpty(window.userInfo)) {
      await UserService.GetUserInfoForce();
    }
    const permittedRoleNames: string[] = ["admin", "manager"];
    const userInfo = window.userInfo as IUserInfoDto;
    const userRoleNames = userInfo.roles.map((role) => role.name);
    if (
      !permittedRoleNames.some((roleName) => userRoleNames.includes(roleName))
    ) {
      await ReactSystemFunctions.goBack(this);

      const language = localStorage.getItem("ml");
      let permissonErrorMessageText =
        "You do not have permission to access this page.";
      if (language === "tr_TR") {
        permissonErrorMessageText = "Bu sayfaya erişim yetkiniz yok.";
      } else if (language === "fr_FR") {
        permissonErrorMessageText =
          "Vous n'avez pas la permission d'accéder à cette page.";
      } else if (language === "de_DE") {
        permissonErrorMessageText =
          "Sie haben keine Berechtigung, auf diese Seite zuzugreifen.";
      } else if (language === "es_ES") {
        permissonErrorMessageText =
          "No tienes permiso para acceder a esta página.";
      }

      KMainFunctions.displayErrorNotification(permissonErrorMessageText);
      state.isPageVisible = false;
      KuikaAppManager.hideSpinner(this);
      return;
    }
    state.isPageVisible = true;
    KuikaAppManager.hideSpinner(this);
  };

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight(
      "stdusers_list",
      "layout2_screen"
    );
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.STDUsers_ListPageInit();
    }

    if (
      prevState.isMasterPageInitLoaded !== this.state.isMasterPageInitLoaded &&
      this.state.isMasterPageInitLoaded === true
    ) {
      await this.STDUsers_ListPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  setMasterPageInitLoaded = (value: boolean) => {
    this.setState({ isMasterPageInitLoaded: value });
  };

  setMasterPageRecurringLoaded = (value: boolean) => {
    this.setState({ isMasterPageRecurringLoaded: value });
  };
  setShouldTriggerPageInit = (value: boolean) => {
    this.setState({ shouldTriggerPageInit: value });
  };

  STDUsers_ListPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      UserName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDUsers_List/STDUsers_ListPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetUserWithGroupDetails = result?.data.getUserWithGroupDetails;
    formVars.stdusers_list_586569_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetUserWithGroupDetails !== undefined
        ? stateVars.GetUserWithGroupDetails?.length > 0
          ? stateVars.GetUserWithGroupDetails[0].fullName
          : null
        : this.state.GetUserWithGroupDetails?.length > 0
        ? this.state.GetUserWithGroupDetails[0].fullName
        : null
    );
    formVars.stdusers_list_527607_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetUserWithGroupDetails !== undefined
        ? stateVars.GetUserWithGroupDetails?.length > 0
          ? stateVars.GetUserWithGroupDetails[0].groupName
          : null
        : this.state.GetUserWithGroupDetails?.length > 0
        ? this.state.GetUserWithGroupDetails[0].groupName
        : null
    );
    stateVars.isComp91272Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].usersCreate
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].usersCreate
            : null
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp352595Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].usersEdit
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].usersEdit
            : null
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp168464Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].usersDelete
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].usersDelete
            : null
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.STDUsers_ListPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDUsers_ListPageInit_if1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "STDUsers_List",
      "NavigateScreen",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  STDUsers_ListPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].usersView
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].usersView
            : null
        ),
        true
      )
    ) {
      isErrorOccurred = await this.STDUsers_ListPageInit_if1();
      if (isErrorOccurred) return true;
    } else {
    }

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.STDUsers_ListPageInit2_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  STDUsers_ListPageInit2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {};

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDUsers_List/STDUsers_ListPageInit2_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetSTDUsersAll = result?.data.getSTDUsersAll;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.STDUsers_ListPageInit3_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDUsers_ListPageInit3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.stdusers_list_586569_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetUserWithGroupDetails !== undefined
        ? stateVars.GetUserWithGroupDetails?.length > 0
          ? stateVars.GetUserWithGroupDetails[0].fullName
          : null
        : this.state.GetUserWithGroupDetails?.length > 0
        ? this.state.GetUserWithGroupDetails[0].fullName
        : null
    );

    formVars.stdusers_list_527607_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetUserWithGroupDetails !== undefined
        ? stateVars.GetUserWithGroupDetails?.length > 0
          ? stateVars.GetUserWithGroupDetails[0].groupName
          : null
        : this.state.GetUserWithGroupDetails?.length > 0
        ? this.state.GetUserWithGroupDetails[0].groupName
        : null
    );

    stateVars.isComp91272Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].usersCreate
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].usersCreate
            : null
        ),
        true
      ) === true
        ? "visible"
        : "hidden";

    stateVars.dataSource_14084 =
      stateVars.GetSTDUsersAll ?? this.state.GetSTDUsersAll;
    stateVars.isComp8751Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, "stdusers_list_14084_value", "status"),
        true
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp433981Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, "stdusers_list_14084_value", "status"),
        false
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp352595Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].usersEdit
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].usersEdit
            : null
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp168464Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].usersDelete
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].usersDelete
            : null
        ),
        true
      ) === true
        ? "visible"
        : "hidden";

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  STDUsers_ListComponent_91272_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "User_Form",
      "STDUserId",
      ReactSystemFunctions.convertToTypeByName(Guid.create().toString(), "Guid")
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "STDUsers_List",
      "User_Form",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "612776",
      null,
      "right",
      "true",
      "450px",
      "100vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  STDUsers_ListComponent_352595_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "User_Form",
      "STDUserId",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "stdusers_list_14084_value", "id"),
        "Guid"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "STDUsers_List",
      "User_Form",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "835967",
      null,
      "right",
      "true",
      "500px",
      "100vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [, 612776, 835967] as number[];
    if (
      isFromMaster ||
      ((window.kuika?.disableSmartExecutePageInit?.["STDUsers_List"] ??
        false) &&
        pageInitCallerNavDiIDs.indexOf(diId) > -1)
    ) {
      await this.STDUsers_ListPageInit();
    } else if (
      window.kuika?.serverRequestCount > 0 &&
      pageInitCallerNavDiIDs.indexOf(diId) > -1
    ) {
      await this.STDUsers_ListPageInit();
    }
  }
}
